import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useUiTheme } from '@/hooks/use-ui-theme';
import OldPOSMenuManagement from './menu-management-old';
import MissionControlMenuManagement from './menu-management-mission-control';
export default function POSMenuManagement(props) {
    const { uiTheme } = useUiTheme();
    return uiTheme === 'classic' ? (_jsx(OldPOSMenuManagement, { ...props })) : (_jsx(MissionControlMenuManagement, { ...props }));
}
